import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { initializeBrowserPostHog } from './lib/posthog';
import { queryClient } from './lib/queryClient';
import '@alliance-strategies/form-engine-portable/style.css';
import './styles.css';

initializeBrowserPostHog();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);

// Offline support (AP-16): static-asset cache + Background Sync wake-ups for
// the IndexedDB upload queue.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}
